<template>
  <v-layout>
    <v-flex>
      <v-form ref="form" v-model="valid">

        <v-text-field label="Motiv" v-model="document.reason">
        </v-text-field>

        <v-textarea label="Constatare" v-model="document.observation">
        </v-textarea>

        <h2>Necesar Piese</h2>

        <v-text-field label="Cod Piesa" v-model="document.needsPieceCode">
        </v-text-field>

        <v-text-field label="Denumire" v-model="document.needsName">
        </v-text-field>

        <v-text-field label="Cantitate" v-model="document.needsQuantity">
        </v-text-field>

        <v-textarea label="Lucrari efectuate" v-model="document.workDone">
        </v-textarea>

        <h2>Piese Inlocuite</h2>

        <v-text-field label="Cod Piesa" v-model="document.changedPieceCode">
        </v-text-field>

        <v-text-field label="Denumire" v-model="document.changedName">
        </v-text-field>

        <v-text-field label="Cantitate" v-model="document.changedQuantity">
        </v-text-field>

        <v-text-field label="Garantie" v-model="document.changedWaranty">
        </v-text-field>

        <h2>Fotografii</h2>

        <v-file-input
          label="Adauga fotografii"
          prepend-icon="mdi-camera"
          accept="image/jpeg,image/png"
          multiple
          @change="onPhotosSelected"
        />

        <v-row v-if="document.photos && document.photos.length">
          <v-col
            v-for="(photo, i) in document.photos"
            :key="i"
            cols="6"
            sm="4"
            md="3"
          >
            <v-img :src="photo" aspect-ratio="1" contain />
            <v-btn small text color="red" @click="removePhoto(i)">Sterge</v-btn>
          </v-col>
        </v-row>

        <SignaturePad ref="signatureRef" />

        <div class="text-xs-right">
          <v-btn @click="submit" color="primary">Salvare</v-btn>
          <v-btn @click="preview" color="primary">Previzualizare</v-btn>
        </div>
      </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
import SignaturePad from '@/components/documents/SignaturePad.vue';
import { busEvent } from '../../main';

export default {
  components: {
    SignaturePad,
  },
  data() {
    return {
      valid: true,
      document: {
        type: 'worksheet',
        reason: 'REVIZIE ANUALA',
        observation: 'APARAT FUNCTIONAL',
        needsPieceCode: '',
        needsName: '',
        needsQuantity: '',
        workDone:
          'CURATARE CAMERA ARDERE, ELECTROZI, CONDUCTA DE CONDENS, VENTILATOR, VERIFICARE PRESIUNE APA, GAZE, REGLAJE, PROBE DE FUNCTIONARE. APARATUL FUNCTIONEAZA IN PARAMETRII NORMALI.',
        changedPieceCode: '',
        changedName: '',
        changedQuantity: '',
        changedWaranty: '',
        signature: null,
        photos: [],
      },
    };
  },

  async created() {
    // get the latest task of customer
    const getLatestTaskOfCustomer = await this.$store.dispatch(
      'tasks/getLatestTaskOfCustomer',
      this.$route.params.clientId
    );

    if (getLatestTaskOfCustomer) {
      this.document.reason = getLatestTaskOfCustomer.title || 'REVIZIE ANUALA'
    }

    // check if we're on edit screen
    if (this.$route.name === 'Editare fisa de lucrari') {
      const document = await this.$store.dispatch('documents/getDocument', {
        clientId: this.$route.params.clientId,
        documentId: this.$route.params.id,
      });

      this.document = {
        ...document.props,
        photos: document.props.photos || [],
        number: document.number,
        documentId: document.id,
      };
      this.$refs.signatureRef.setSignature(document.props.signature);
    }
  },
  methods: {
    resizeImage(file, maxWidth = 1024, quality = 0.7) {
      return new Promise((resolve) => {
        const img = new Image();
        const url = URL.createObjectURL(file);
        img.onload = () => {
          const scale = Math.min(1, maxWidth / img.width);
          const canvas = document.createElement('canvas');
          canvas.width = img.width * scale;
          canvas.height = img.height * scale;
          canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
          URL.revokeObjectURL(url);
          resolve(canvas.toDataURL('image/jpeg', quality));
        };
        img.src = url;
      });
    },
    async onPhotosSelected(files) {
      if (!files || !files.length) return;
      const encoded = await Promise.all([...files].map((f) => this.resizeImage(f)));
      this.document.photos = [...(this.document.photos || []), ...encoded];
    },
    removePhoto(index) {
      this.document.photos = this.document.photos.filter((_, i) => i !== index);
    },
    submit() {
      if (this.$refs.form.validate() && this.valid) {
        this.document.signature = this.$refs.signatureRef.getSignature();

        if (this.$route.name === 'Editare fisa de lucrari') {
          this.$store
            .dispatch('documents/update', {
              clientId: this.$route.params.clientId,
              body: this.document,
            })
            .then(() => {
              busEvent.$emit(
                'succesPopupCreated',
                'Fisa de lucrari a fost editata'
              );
              this.$router.back();
            });
        } else {
          this.$store
            .dispatch('documents/create', {
              clientId: this.$route.params.clientId,
              body: this.document,
            })
            .then(() => {
              busEvent.$emit(
                'succesPopupCreated',
                'Fisa de lucrari a fost creata'
              );
              this.$router.back();
            });
        }
      }
    },
    async preview() {
      if (this.$refs.form.validate() && this.valid) {
        this.document.signature = this.$refs.signatureRef.getSignature();

        const response = await this.$store.dispatch('documents/preview', {
          clientId: this.$route.params.clientId,
          body: this.document,
        });

        const fileURL = window.URL.createObjectURL(new Blob([response.data]));
        const fileLink = document.createElement('a');
        fileLink.href = fileURL;
        const fileName =
          response.headers['content-disposition'].match("filename='(.*)'");
        fileLink.setAttribute('download', fileName[1]);
        document.body.appendChild(fileLink);
        fileLink.click();
        fileLink.remove();
      }
    },
  },
};
</script>

<style></style>
